module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pt-2 pt-md-4 page-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.columnFaqs), function(faqs) {
    return _c('div', {
      key: faqs,
      staticClass: "col-lg-6"
    }, _vm._l((faqs), function(faq) {
      return _c('faq-collapse', {
        key: faq.id,
        attrs: {
          "faq": faq
        }
      })
    }), 1)
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("FAQ\n        "), _c('br'), _vm._v("(Perguntas Frequentes)\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27568633","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Faq/Faq.vue
// module id = 347
// module chunks = 1